/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import Head from 'next/head';
import Header24 from '@/components/organisms/Header24';
import Footer24 from '@/components/organisms/Footer24';
import Styles from './LeilaoDeVeiculos.css';
import LeilaoDeVeiculosBlog from '@/components/organisms/LeilaoDeVeiculosBlog';
import FaqLPs25 from '@/components/molecules/FaqLPs25';
import LeilaoDeVeiculosBanner from '@/components/organisms/LeilaoDeVeiculosBanner';
import LeilaoDeVeiculosDatas from '@/components/organisms/LeilaoDeVeiculosDatas';
import LeilaoDeVeiculosConheca from '@/components/organisms/LeilaoDeVeiculosConheca';
import LeilaoDeVeiculosPassoAPasso from '@/components/organisms/LeilaoDeVeiculosPassoAPasso';
import LeilaoDeVeiculosFiqueAtento from '@/components/organisms/LeilaoDeVeiculosFiqueAtento';

function LeilaoDeVeiculos() {
  const faqTitle = 'Saiba mais sobre leilão de veículos';
  const imgpng = 'assets/leilao-de-veiculos/img-perguntas.jpg';
  const imgwebp = 'assets/leilao-de-veiculos/img-perguntas.webp';
  const imgpngdesk = 'assets/leilao-de-veiculos/img-perguntas-desk.jpg';
  const imgwebpdesk = 'assets/leilao-de-veiculos/img-perguntas-desk.webp';
  const imgalt =
    'Mulher sorrindo ao celular ao lado de carro comprado em leilão de veículos homologado pela Santander Financiamentos.';
  const linkMostrarTodasPerguntas = 'duvidas-frequentes.html';
  const faqs = [
    {
      pergunta: 'Quais são as vantagens do leilão?',
      resposta: `O leilão de carros e motos oferece diversas vantagens para quem busca um veículo com bom custo-benefício. Veja alguns dos principais benefícios:<br/><br/>
      •	Preços atrativos, muitas vezes abaixo do valor da tabela FIPE;<br/>
      •	Processo organizado, com data e horário definidos para início e término do leilão;<br/>
      •	 Os leilões homologados pelo Santander garantem segurança para a sua negociação.
      `,
    },
    {
      pergunta: 'Quais são os cuidados que devo ter com um leilão de veículos?',
      resposta: `Embora o leilão de veículos ofereça ótimas oportunidades, é fundamental tomar alguns cuidados para garantir uma boa compra. Veja o que considerar:<br/><br/>
      •	Inspecione o veículo antes do leilão, sempre que possível, para identificar possíveis avarias ou pendências;<br/>
      •	Consulte o valor do modelo desejado na tabela FIPE e defina um limite máximo de lance, evitando pagar acima do valor de mercado;<br/><br/>
      Com esses cuidados, você aumenta suas chances de fazer um bom negócio e escolher o veículo mais adequado às suas necessidades.
      `,
    },
    {
      pergunta: 'Os veículos leiloados estão em bom estado?',
      resposta: `Nem sempre. Os veículos podem estar em diferentes condições — desde conservados até sinistrados. É essencial ler o edital e, se possível, visitar o pátio para ver as opções de veículos.`,
    },
    {
      pergunta: 'Quem pode participar do leilão?',
      resposta: `Qualquer pessoa maior de 18 anos com CPF ou CNPJ regular pode participar, desde que aceite os termos do edital.`,
    },
  ];
  return (
    <>
      <Head>
        <title>Leilão de veículos | Santander Financiamentos</title>
        <meta
          name="Description"
          content="Conhecendo leilões oficiais de veículos com a Santander Financiamentos! Datas, locais e oportunidades de arrematar carros com leiloeiros credenciados"
        />
        <meta name="robots" content="index,follow" />
        <meta
          name="keywords"
          content="Leilão de carros em São Paulo, Leilão de carros em SP, Leilão de carros baratos, Como participar de leilão de carros, Leilão de carros recuperados, Leilão de motos usadas, Leilão de veículos online, Leilão seguro de carros, qual o melhor leilão de carros, como saber se um carro é de leilão, como comprar carro de leilão, onde comprar carro de leilão, Leilão de motos, Leilão Santander, Sucatas, Carros de leilão, Leilão de veículos, Leilão judicial, Leilão de veículos SP, Repasse de veículos, Vale a pena comprar carro de leilão?, Calendário de leilões, Como comprar em leilão, Veículos de leilão, leilao de carros em sc"
        />
        <link
          rel="canonical"
          href="https://www.santander.com.br/hotsite/santanderfinanciamentos/leilao-de-veiculos.html"
        />
        {/* <!-- OPEN GRAPH TAGS FOR FACEBOOK, WHATSAPP AND LINKEDIN --> */}
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:title" content="Leilão de veículos | Santander Financiamentos" />
        <meta
          property="og:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/leilao-de-veiculos.html "
        />
        <meta property="og:site_name" content="Santander Financiamentos" />
        <meta
          property="og:description"
          content="Conhecendo leilões oficiais de veículos com a Santander Financiamentos! Datas, locais e oportunidades de arrematar carros com leiloeiros credenciados"
        />
        <meta
          property="og:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/leilao-de-veiculos/hero/banner-1440.webp"
        />
        <meta
          property="og:image:alt"
          content="Homem ao lado de carro em estacionamento de pátio de leilão, simbolizando compra a compra de seu veículo em m leilão de veículos homologado pela Santander Financiamentos."
        />
        <meta property="og:image:type" content="image/webp" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />
        <meta property="og:type" content="website" />

        {/* <!-- TWITTER CARDS FOR TWITTER --> */}
        <meta name="twitter:card" content="" />
        <meta name="twitter:title" content="Leilão de veículos | Santander Financiamentos" />
        <meta
          name="twitter:description"
          content="Conhecendo leilões oficiais de veículos com a Santander Financiamentos! Datas, locais e oportunidades de arrematar carros com leiloeiros credenciados"
        />
        <meta
          name="twitter:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/leilao-de-veiculos.html "
        />
        <meta
          property="twitter:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/leilao-de-veiculos/hero/banner-1440.webp"
        />
        <meta
          property="twitter:image:alt"
          content="Homem ao lado de carro em estacionamento de pátio de leilão, simbolizando compra a compra de seu veículo em m leilão de veículos homologado pela Santander Financiamentos."
        />
        <meta property="twitter:image:type" content="image/webp" />
        <meta property="twitter:image:width" content="1200" />
        <meta property="twitter:image:height" content="627" />
      </Head>
      <Header24 isHome24 />
      <LeilaoDeVeiculosBanner />
      <LeilaoDeVeiculosConheca />
      <LeilaoDeVeiculosPassoAPasso />
      <LeilaoDeVeiculosDatas />
      <LeilaoDeVeiculosFiqueAtento />
      <FaqLPs25
        imgpng={imgpng}
        imgwebp={imgwebp}
        imgpngdesk={imgpngdesk}
        imgwebpdesk={imgwebpdesk}
        imgalt={imgalt}
        faqtitle={faqTitle}
        faqs={faqs}
        linkMostrarTodasPerguntas={linkMostrarTodasPerguntas}
      />
      <LeilaoDeVeiculosBlog />
      <Footer24 />
      <style jsx>{Styles}</style>
    </>
  );
}

export default LeilaoDeVeiculos;
